/**
 * This is a polyfill library that enables IE 11 to run modern websites
 * Do not use Babel as it conflicts with Google Maps API library
 */
// import "core-js/stable";
import 'regenerator-runtime/runtime';

window.axios = require('axios');
window.Vue = require('vue').default;
import Slick from 'vue-slick-carousel'
import vueDebounce from 'vue-debounce'

Vue.use(vueDebounce)

Vue.component('app-header', () => import('./components/Header'));
Vue.component('app-slideshow-services', () => import('./components/SliderServices'));
Vue.component('app-slideshow-projects', () => import('./components/SliderProjects'));
Vue.component('app-our-people', () => import('./components/OurPeople'));
Vue.component('app-gallery', () => import('./components/GalleryArea'));
Vue.component('app-collapsible', () => import('./components/Collapsible'));
Vue.component('app-tabs', () => import('./components/Tabs'));
Vue.component('app-video', () => import('./components/Video'));

Vue.component('meet-the-team', () => import('./components/MeetTheTeam/Container'));

Vue.component('app-map', () => import('./components/Map'));

const app = new Vue({
  el: '#app',
  components: { Slick },

  data: () => ({
    isLoaded: false,
  }),

  mounted () {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.isLoaded = true
      }
    }
  },

  methods: {}
});
